export const environment = {
  production: true,
  hereMapKey: 'E52kurNWSaKGtwzusElIgRpFS-C0DB59yIyHdEUGZAY'
};
